var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from 'react';
import axios from 'axios';
import { getGlobalState, setGlobalState } from '../Utils/GlobalState';
export default (endpoint, callback, globalStateKey) => {
    useEffect(() => {
        let isMounted = true;
        if (globalStateKey && getGlobalState(globalStateKey)) {
            callback(getGlobalState(globalStateKey));
        }
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const applicationUrl = getGlobalState('application_url');
            const result = yield axios.get(`${applicationUrl}${endpoint}`, { withCredentials: true });
            if (isMounted) {
                if (globalStateKey) {
                    setGlobalState(globalStateKey, result.data);
                }
                callback(result.data);
            }
        }))();
        return () => {
            isMounted = false;
        };
    }, []);
};
